export type PlanKey = 'free' | 'familiar' | 'premium';

/**
 * IMPORTANTE: Estos valores son SOLO FALLBACK
 * La fuente de verdad para límites y cuotas es la colección 'subscriptionPlans' en Firestore
 * Los IDs de PlanKey coinciden EXACTAMENTE con los IDs de documentos en subscriptionPlans:
 * - 'free' → subscriptionPlans/free
 * - 'familiar' → subscriptionPlans/familiar
 * - 'premium' → subscriptionPlans/premium (enterprise)
 */
export const PLANS: Record<PlanKey, { label: string; priceMonthly: number; familyQuota: number }> = {
  free: {
    label: 'Gratis',
    priceMonthly: 0,
    familyQuota: 1,
  },
  familiar: {
    label: 'Familiar',
    priceMonthly: 9.99,
    familyQuota: 2,
  },
  premium: {
    label: 'Premium',
    priceMonthly: 14.99,
    familyQuota: 3,
  },
};

export function getPlanKey(input: any): PlanKey {
  const v = String(input || '').toLowerCase();
  if (v.includes('premium') || v.includes('enterprise')) return 'premium';
  if (v.includes('family') || v.includes('familiar')) return 'familiar';
  if (v.includes('free') || v === '' || v === 'none' || v === 'null' || v === 'undefined') return 'free';
  // fallback para valores desconocidos
  return 'free';
}
